<template>
  <div class="index-portale" v-if="isToken">
    <header-app @showMessages="changeShowMessages" :counterNuovi="counterNuovi" :counterBacheca="counterBacheca"></header-app>
    <div>
      <nav-left :height="navBarHeight" class="menu"></nav-left>

      <keep-alive>
        <router-view @closeMessages="closeMessages" class="contenuto" :style="{ width: contentWidth + 'px'}"
                     :showMessages="showMessages" :contenitoreHeight="contenitoreHeight"></router-view>
      </keep-alive>
      <messages v-show="showMessages.val" @changeCounterNuovi="changeCounterNuovi" @changeCounterBacheca="changeCounterBacheca"
                :showMessages="showMessages" :height="messagesHeight" @closeMessages="closeMessages"></messages>
    </div>
  </div>
</template>

<script>
  import HeaderApp from '@/components/HeaderApp'
  import NavLeft from '@/components/NavLeft'
  import Messages from '@/components/Messages'
  import {bus} from './Bus'

  export default {
    name: 'IndexPortale',
    components: {HeaderApp, NavLeft, Messages},
    watch: {
      '$mq.resize': 'setSizes',
      'showMessages.val': function (newVal, oldVal) {
        this.setSizes()
      }
    },
    mounted: function () {
      if (document.documentElement.clientWidth <= 1280) {
        this.$set(this.showMessages, 'val', false)
      }
      this.setSizes()
    },
    data () {
      return {
        showMessages: {
          val: true,
          type: 0
        },
        navBarHeight: 0,
        messagesHeight: 0,
        contenitoreHeight: 0,
        contentWidth: 0,
        counterNuovi: 0,
        counterBacheca: 0
      }
    },
    computed: {
      isToken: function () {
        if (sessionStorage.getItem('token')) {
          return true
        } else {
          this.$router.push({name: 'Login'})
          return false
        }
      }
    },
    methods: {
      changeCounterNuovi: function (counterNuovi) {
        this.$set(this, 'counterNuovi', counterNuovi)
      },
      changeCounterBacheca: function (counterBacheca) {
        this.$set(this, 'counterBacheca', counterBacheca)
      },
      setSizes: function () {
        if (document.documentElement.clientWidth <= 1650 && this.showMessages.type === 0) {
          this.$set(this.showMessages, 'val', false)
        }
        this.setHeight()
        this.setContentWidth()
      },
      setHeight: function () {
        let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        this.$set(this, 'navBarHeight', (height - 57))
        this.$set(this, 'messagesHeight', (height - 174))
        this.$set(this, 'contenitoreHeight', (height - 140))
      },
      setContentWidth: function () {
        let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        this.$set(this, 'contentWidth', ((this.showMessages.val && this.showMessages.type === 0) ? (width - 495) : (width - 90)))
      },
      changeShowMessages: function () {
        this.$set(this.showMessages, 'val', !this.showMessages.val)
        if (document.documentElement.clientWidth > 1650) {
          this.$set(this.showMessages, 'type', 0)
          bus.$emit('Portale_DrawChart')
        } else {
          this.$set(this.showMessages, 'type', 1)
        }
      },
      closeMessages: function () {
        this.$set(this.showMessages, 'val', false)
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/general.less";

  .index-portale {
    .set-font();
    height: 100%;
    .menu {
      float: left;
    }
    .contenuto {
      float: left;
      margin-left: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexPortale.vue